module.exports = __webpack_public_path__ + "static/img/shouc.ac9d27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouc.png
// module id = I1Tx
// module chunks = 1